interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref = '#',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500" />
            <span className="text-xs font-medium tracking-wide text-primary-700">{eyebrow}</span>
          </div>
        )}
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">{title}</h2>
        {desc && <p className="mt-2 text-sm md:text-base text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && (
        <a
          href={actionHref}
          className="group inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </a>
      )}
    </div>
  );
}